<div [formGroup]="form" class="pet-tile-form-container">
  <div class="row no-gutters" role="form">
    <div class="col-auto">
      <mat-checkbox
        #tile
        [checked]="isPetSelected"
        (change)="tile.checked !== isPetSelected && togglePetSelected()"
        style="margin-right: 0.625rem"
      ></mat-checkbox>
    </div>
    <div class="col">
      <ng-container *ngIf="petInfo; else showInput">
        <div class="clickable" (click)="togglePetSelected($event)">
          <div class="lato bold primary mt-1">
            {{
              petInfo.firstName
                ? petInfo.firstName + " " + petInfo.lastName
                : petInfo.nickName
            }}
          </div>
          <div class="pet-info-table">
            <div class="row no-gutters">
              <div class="pet-info-label pr-2">Breed:</div>
              <div class="pet-tile-form-content">{{ breedNameList }}</div>
            </div>
            <div
              class="row no-gutters"
              *ngIf="petInfo?.weight && petInfo.weight?.weight"
            >
              <div class="pet-info-label pr-2">Weight:</div>
              <div class="pet-tile-form-content">
                {{ (petInfo.weight?.weight | convertUnit: "g":"lb") + " lbs" }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #showInput>
        <div class="row no-gutters">
          <div class="input-container col" style="padding-right: 0.625rem">
            <!-- CBW-784 Names -->
            <span class="input-label">First Name</span>
            <input type="text" class="input" formControlName="firstName" />
            <span
              class="error"
              *ngIf="f.firstName.touched && f.firstName.value === ''"
              >Please enter dog's first name.</span
            >
          </div>
          <div class="input-container col" style="padding-right: 0.625rem">
            <span class="input-label">Last Name</span>
            <input type="text" class="input" formControlName="lastName" />
            <span
              class="error"
              *ngIf="f.lastName.touched && f.lastName.value === ''"
              >Please enter dog's last name.</span
            >
          </div>
        </div>
        <div class="input-container" formArrayName="breedArr">
          <span class="input-label">Breed</span>
          <div
            *ngFor="
              let breed of breedFormArray.controls;
              let i = index;
              let isLastChild = last
            "
            [formGroupName]="i"
            [style.margin-bottom]="!isLastChild ? '0.875rem' : '0'"
          >
            <div class="row no-gutters">
              <div class="col d-flex" #breedDropdown>
                <div style="flex: 1">
                  <input
                    type="text"
                    class="input"
                    formControlName="name"
                    (blur)="blurBreed(i)"
                    matInput
                    [matAutocomplete]="auto"
                    #trigger="matAutocompleteTrigger"
                  />
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    [displayWith]="getBreedLabel"
                    (optionSelected)="filterBreedsOption()"
                  >
                    <mat-option
                      *ngFor="let option of filteredBreeds[i] | async"
                      [value]="option"
                      (mousedown)="$event.preventDefault()"
                    >
                      {{ option.label }}
                    </mat-option>
                  </mat-autocomplete>
                </div>
                <div
                  class="icon-container"
                  (click)="$event.stopPropagation(); trigger.openPanel()"
                >
                  <img
                    src="assets/svg/ico_arrow_down_teal.svg"
                    alt="Arrow Down Icon"
                    width="15"
                  />
                </div>
              </div>
              <div class="col-auto d-flex">
                <div
                  *ngIf="i !== 0"
                  class="icon-container trash"
                  (click)="removeBreed(i)"
                >
                  <img
                    src="assets/svg/ico_trash_can.svg"
                    alt="Trash Can Icon"
                    width="15"
                  />
                </div>
              </div>
            </div>
            <span
              class="error"
              [style.width.px]="breedDropdown.offsetWidth"
              *ngIf="
                breed.get('name').touched && breed.get('name').value === ''
              "
              >Please select a breed.</span
            >
          </div>
          <div class="mt-2">
            <app-arrow-link-right
              text="+ Add a Breed"
              (handleClick)="addBreed()"
            ></app-arrow-link-right>
          </div>
        </div>
        <div class="input-container">
          <span class="input-label">Weight (lbs)</span>
          <input
            type="number"
            min="0"
            class="input"
            formControlName="weight"
            (blur)="blurWeight()"
          />
          <span *ngIf="f['weight'].touched && !f['weight'].value" class="error"
            >Please enter weight.</span
          >
        </div>
      </ng-template>
      <div *ngIf="isPetSelected" style="margin-top: 0.5rem">
        <div class="pet-tile-form-content mb-4">
          I agree my dog meets the Camper Requirements below (select all that
          apply):
        </div>
        <div
          *ngFor="let agreementItem of agreementList; let i = index"
          style="margin-bottom: 1rem"
        >
          <div class="row no-gutters">
            <div class="col-auto pr-2">
              <mat-checkbox
                #elem
                color="primary"
                [checked]="isAgreementSelected(i)"
                (change)="
                  elem.checked !== isAgreementSelected(i) &&
                    toggleAgreementItem(i)
                "
              ></mat-checkbox>
            </div>
            <div class="col pet-tile-form-content pt-1">
              <span class="clickable" (click)="toggleAgreementItem(i)">{{
                agreementItem.message
              }}</span>
              <div
                *ngIf="isErrorOnSave && !isAgreementSelected(i)"
                class="row no-gutters"
              >
                <div class="col-auto pr-1">
                  <img
                    src="assets/svg/ico_error_circle.svg"
                    alt="Error icon"
                    width="12"
                  />
                </div>
                <div class="col primary pt-1" style="font-size: 0.75rem">
                  {{ agreementItem.errorMessage }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--
        <div class="input-container" style="margin-bottom: 0.25rem">
          <div class="d-flex">
            <div style="flex: 1">
              <span class="input-label"
                >Anything you'd like us to know about your pup</span
              >
            </div>
            <div>
              <span class="input-label italic">* Optional</span>
            </div>
          </div>
          <textarea
            class="input input-textarea"
            rows="3"
            formControlName="petDetails"
          ></textarea>
        </div>
        -->
      </div>
    </div>
  </div>
</div>
